var _excluded = ["align", "children", "gap", "valign", "vertical", "wrap"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
var TRANSIENT_PROPS = ['wrap'];
var LayoutContainer = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => {
    return defaultValidatorFn(prop) && !TRANSIENT_PROPS.includes(prop);
  }
}).withConfig({
  componentId: "CL__sc-1972358-0"
})(["display:flex;--layout-gap:", ";& > *:not(:last-child),& > *[class]:not(:last-child){margin:0 var(--layout-gap) 0 0;}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], _ref => {
  var {
    gap
  } = _ref;
  return gap;
}, _ref2 => {
  var {
    align,
    vertical
  } = _ref2;
  return !vertical && align === 'left' ? "\n      justify-content: flex-start;\n    " : "";
}, _ref3 => {
  var {
    align,
    vertical
  } = _ref3;
  return !vertical && align === 'right' ? "\n      justify-content: flex-end;\n    " : "";
}, _ref4 => {
  var {
    align,
    vertical
  } = _ref4;
  return !vertical && align === 'center' ? "\n      justify-content: center;\n    " : "";
}, _ref5 => {
  var {
    align,
    vertical
  } = _ref5;
  return !vertical && align === 'justify' ? "\n      justify-content: space-between;\n    " : "";
}, _ref6 => {
  var {
    valign,
    vertical
  } = _ref6;
  return !vertical && valign === 'top' ? "\n      align-items: flex-start;\n    " : "";
}, _ref7 => {
  var {
    valign,
    vertical
  } = _ref7;
  return !vertical && valign === 'bottom' ? "\n      align-items: flex-end;\n    " : "";
}, _ref8 => {
  var {
    valign,
    vertical
  } = _ref8;
  return !vertical && valign === 'center' ? "\n      align-items: center;\n    " : "";
}, _ref9 => {
  var {
    valign,
    vertical
  } = _ref9;
  return !vertical && valign === 'justify' ? "\n      align-items: stretch;\n    " : "";
}, _ref0 => {
  var {
    vertical
  } = _ref0;
  return vertical ? "\n      flex-direction: column;\n\n      & > *:not(:last-child),\n      & > *[class]:not(:last-child) {\n        margin: 0 0 var(--layout-gap);\n      }\n    " : "";
}, _ref1 => {
  var {
    align,
    vertical
  } = _ref1;
  return vertical && align === 'left' ? "\n      align-items: flex-start;\n    " : "";
}, _ref10 => {
  var {
    align,
    vertical
  } = _ref10;
  return vertical && align === 'right' ? "\n      align-items: flex-end;\n    " : "";
}, _ref11 => {
  var {
    align,
    vertical
  } = _ref11;
  return vertical && align === 'center' ? "\n      align-items: center;\n    " : "";
}, _ref12 => {
  var {
    align,
    vertical
  } = _ref12;
  return vertical && align === 'justify' ? "\n      align-items: stretch;\n    " : "";
}, _ref13 => {
  var {
    valign,
    vertical
  } = _ref13;
  return vertical && valign === 'top' ? "\n      justify-content: flex-start;\n    " : "";
}, _ref14 => {
  var {
    valign,
    vertical
  } = _ref14;
  return vertical && valign === 'bottom' ? "\n      justify-content: flex-end;\n    " : "";
}, _ref15 => {
  var {
    valign,
    vertical
  } = _ref15;
  return vertical && valign === 'center' ? "\n      justify-content: center;\n    " : "";
}, _ref16 => {
  var {
    valign,
    vertical
  } = _ref16;
  return vertical && valign === 'justify' ? "\n      justify-content: space-between;\n    " : "";
}, _ref17 => {
  var {
    wrap,
    vertical
  } = _ref17;
  return wrap && !vertical ? "\n      flex-wrap: wrap;\n\n      /* Need to select both :last-child and :not(:last-child) to override specifity on the default margin */\n      & > *:last-child,\n      & > *:not(:last-child),\n      & > *[class]:not(:last-child) {\n        margin: 0 var(--layout-gap) var(--layout-gap) 0;\n      }\n    " : "";
});
var Layout = /*#__PURE__*/React.forwardRef((_ref18, ref) => {
  var {
      align = 'left',
      children = '',
      gap = 'var(--spacing-2)',
      valign = 'center',
      vertical = false,
      wrap = false
    } = _ref18,
    props = _objectWithoutProperties(_ref18, _excluded);
  return /*#__PURE__*/React.createElement(LayoutContainer, _extends({
    align: align,
    gap: gap,
    ref: ref,
    valign: valign,
    vertical: vertical,
    wrap: wrap
  }, props), children);
});
export default Layout;